<template>
  <layout-basic>
    <v-container class="te-wrap">
      <div class="te-card">
        <v-icon size="48" color="#08a0a8" class="mb-3">mdi-flag-checkered</v-icon>
        <h1 class="te-title">Your IMPROVE trial has ended</h1>
        <p class="te-subtitle">
          Thank you for exploring IMPROVE. To keep your account, your people and the
          courses you set up, choose a package and purchase IMPROVE. Once you do, you
          can upload the rest of your workforce and begin the Launch Programme.
        </p>
        <div class="te-actions">
          <v-btn color="primary" depressed large :to="buyRoute" style="text-transform:none">Buy IMPROVE</v-btn>
          <v-btn v-if="webinarShown" outlined color="directHeader" large style="text-transform:none" @click="openWebinar">Book webinar</v-btn>
        </div>
        <p class="te-help">
          Have a question? Email <a href="mailto:info@improve.online">info@improve.online</a>.
        </p>
      </div>
    </v-container>
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import { openWebinarBooking, webinarAvailable } from '@/utils/webinarBooking';

export default {
  name: 'TrialEnded',
  components: { LayoutBasic },
  computed: {
    // Same resilient resolve as TrialCountdown: the in-app buy page where it
    // exists, otherwise the account status page.
    buyRoute() {
      const r = this.$router.resolve('/billing');
      return r && r.route && r.route.matched.length ? '/billing' : '/admin/finance/account-status';
    },
    // An ended trial can still book an IMPROVE Live webinar (6 Oct 2026).
    webinarShown() {
      return webinarAvailable();
    },
  },
  methods: {
    openWebinar() {
      openWebinarBooking();
    },
  },
};
</script>

<style scoped>
.te-wrap { max-width: 720px; margin: 0 auto; }
.te-card {
  text-align: center;
  padding: 48px 40px;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(123, 200, 163, 0.18), rgba(22, 43, 68, 0.06)), #fff;
  border: 1px solid rgba(22, 43, 68, 0.08);
}
.te-title { font-size: 28px; font-weight: 700; color: #002458; line-height: 1.2; margin: 0 0 12px 0; }
.te-subtitle { font-size: 16px; line-height: 1.55; color: #5a6a7a; margin: 0 auto 24px auto; max-width: 560px; }
.te-actions { display: flex; flex-wrap: wrap; gap: 14px; justify-content: center; }
.te-help { font-size: 14px; color: #5a6a7a; margin-top: 24px; }
</style>
